import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  useTheme,
} from '@mui/material';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';

interface DigitProps {
  sequencesPresented: string[];
  sequencesEnabled: string[];
  sequencesRecalled: string[];
  setCorrectResponse: (digit: string) => void;
  setIncorrectResponse: (digit: string) => void;
}

export function Digits({
  sequencesPresented,
  sequencesEnabled,
  sequencesRecalled,
  setCorrectResponse,
  setIncorrectResponse,
}: DigitProps) {
  const { t } = useCustomTranslation('assessment');
  const theme = useTheme();
  const [digits, setDigitsSelection] = useState(new Map());

  const handleSingleSelection = (key: string, value: string) => {
    setDigitsSelection(new Map(digits.set(key.toString(), value.toString())));
    if (value === t('ID_GENERIC_CORRECT')) {
      setCorrectResponse(key.toString());
    } else {
      setIncorrectResponse(key.toString());
    }
  };

  const getSelected = (key: string, value: string) => {
    if (
      sequencesRecalled &&
      sequencesRecalled[key as keyof typeof sequencesRecalled] === value
    ) {
      return true;
    }
    return digits.get(key) === value;
  };

  return (
    <>
      {sequencesPresented?.map((digitSequence: string) => {
        return (
          <Card key={digitSequence} elevation={0}>
            <CardContent>
              <Stack direction="column" alignItems="center">
                {digitSequence}
                <Stack direction="row">
                  <ToggleButtonGroup
                    key={digitSequence}
                    aria-label={digitSequence}
                    exclusive
                    onChange={(event, _value) =>
                      handleSingleSelection(digitSequence.toString(), _value)
                    }
                  >
                    <ToggleButton
                      sx={{
                        minWidth: 50,
                        '&.Mui-selected, &.Mui-selected:hover': {
                          color: theme.palette.primary.contrastText,
                          backgroundColor: theme.palette.primary.light,
                          opacity: 0.8,
                        },
                      }}
                      selected={getSelected(
                        digitSequence,
                        t('ID_GENERIC_CORRECT'),
                      )}
                      disabled={!sequencesEnabled.includes(digitSequence)}
                      value={t('ID_GENERIC_CORRECT')}
                      size="small"
                    >
                      {t('ID_GENERIC_CORRECT')}
                    </ToggleButton>
                    <ToggleButton
                      sx={{
                        minWidth: 50,
                        '&.Mui-selected, &.Mui-selected:hover': {
                          color: theme.palette.primary.contrastText,
                          backgroundColor: theme.palette.primary.light,
                          opacity: 0.8,
                        },
                      }}
                      selected={getSelected(
                        digitSequence,
                        t('ID_GENERIC_INCORRECT'),
                      )}
                      disabled={!sequencesEnabled.includes(digitSequence)}
                      value={t('ID_GENERIC_INCORRECT')}
                      size="small"
                    >
                      {t('ID_GENERIC_INCORRECT')}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        );
      })}
    </>
  );
}
